<div class="pr-grid right" style="width: 100%">
  @if (!isUiTest) {
    <irb-inventory-grid id="com-pr-cash-values-grid"
      [style.width] = "'100%'"
      [style.height] = "gridHeight"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      [componentName]="componentName"
      [frameworkComponents] = 'frameworkComponents'
      [rowData] = 'data.accRebalDTOList'
      [popupParent]="popupParent"
      (gridReady) = "onGridReady($event)"
      (columnVisible) = 'onColumnVisible($event)'></irb-inventory-grid>
  }
  <div>
    <div class="ag-primary-cols-reset-header-panel" (click)="resetGridColumns()">
      <div class="resetIcon"></div>
      <div class="resetText">Reset columns</div>
    </div>
  </div>
</div>

<ng-template #comPrCashValuesAccountOverlay>
  <irb-com-pr-cash-values-account-overlay [row]="row"></irb-com-pr-cash-values-account-overlay>
</ng-template>
<ng-template #comPrCashValuesUnavailableCashOverlay>
  @if (row) {
    <div style="min-width: 240px;">
      <table width='100%'>
        <tr>
          <td>Set-aside Cash</td>
          <td class="alignRight">${{row.accountSetAsideCash | number: "1.2-2"}}</td>
        </tr>
        <tr>
          <td>Extra Cash</td>
          <td class="alignRight">${{row.accountExtraCash | number: "1.2-2"}}</td>
        </tr>
        @if (isDistHoldCashEnabled) {
          <tr>
            <td>Distribution Hold</td>
            <td class="alignRight">${{row.distributionHoldAmt | number: "1.2-2"}}</td>
          </tr>
        }
      </table>
    </div>
  }
</ng-template>
